import { jsxs as l, jsx as C } from "react/jsx-runtime";
const o = ({ ...t }) => /* @__PURE__ */ l(
  "svg",
  {
    width: "18",
    height: "4",
    viewBox: "0 0 18 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9 3.125C9.62132 3.125 10.125 2.62132 10.125 2C10.125 1.37868 9.62132 0.875 9 0.875C8.37868 0.875 7.875 1.37868 7.875 2C7.875 2.62132 8.37868 3.125 9 3.125Z",
          fill: "#0C3D3D"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M16.875 3.125C17.4963 3.125 18 2.62132 18 2C18 1.37868 17.4963 0.875 16.875 0.875C16.2537 0.875 15.75 1.37868 15.75 2C15.75 2.62132 16.2537 3.125 16.875 3.125Z",
          fill: "#0C3D3D"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M1.125 3.125C1.74632 3.125 2.25 2.62132 2.25 2C2.25 1.37868 1.74632 0.875 1.125 0.875C0.50368 0.875 0 1.37868 0 2C0 2.62132 0.50368 3.125 1.125 3.125Z",
          fill: "#0C3D3D"
        }
      )
    ]
  }
);
export {
  o as SpreadDotsIcon
};
